var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t("resetComplete")))]),_c('p',{staticClass:"mx-auto text-center mt-4 mb-4"},[_c('strong',[_vm._v(" "+_vm._s(_vm.$t("passwordComplete"))+" "),_c('router-link',{attrs:{"to":"/login"}},[_vm._v(_vm._s(_vm.$t("login")))])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }